import React from 'react';
import withIcon from '../utilities/withIcon';

const IconTrash = () => {
  return (
    <g>
      <path d="M9.583 0a1.25 1.25 0 0 1 1.2.902l.03.125L11.171 3 15.25 3a.75.75 0 1 1 0 1.5h-1.298l-.673 10.335a1.25 1.25 0 0 1-1.117 1.162l-.13.006H3.968a1.25 1.25 0 0 1-1.232-1.039l-.015-.13L2.048 4.5.75 4.5a.75.75 0 0 1 0-1.5h4.079l.359-1.973A1.25 1.25 0 0 1 6.289.007L6.417 0h3.166zm2.867 4.5H3.551l.651 10.002h7.595L12.45 4.5zm-6.226 2c.4 0 .724.324.724.724v4.552a.724.724 0 0 1-1.448 0V7.224c0-.4.324-.724.724-.724zm3.526 0a.75.75 0 0 1 .75.75v4.5a.75.75 0 1 1-1.5 0v-4.5a.75.75 0 0 1 .75-.75zm-.376-5H6.626L6.352 3h3.294l-.272-1.5z" />
    </g>
  );
};

export default withIcon(IconTrash);
